const menu = () => {
  const menuBtn = document.querySelector('.js-menu');
  const header = document.querySelector('.js-header');
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      header.classList.toggle('is-active');
    });
  }
  const submenuBtn = document.querySelectorAll('.js-submenu-trigger');
  if (submenuBtn) {
    submenuBtn.forEach(element => {
      element.addEventListener('click', () => {
        const submenus = document.querySelectorAll('.js-submenu');
        const submenu = element.querySelector('.js-submenu');
        if (submenus) {
          submenus.forEach(el => {
            if (el !== submenu) {
              el.classList.remove('is-active');
            }
          });
        }
        submenu.classList.toggle('is-active');
      });
    });
  }
  const footerBtn = document.querySelectorAll('.js-footer-trigger');
  if (footerBtn) {
    footerBtn.forEach(element => {
      element.addEventListener('click', () => {
        const footers = document.querySelectorAll('.js-footer');
        const footer = element.parentElement.querySelector('.js-footer');
        if (footers) {
          footers.forEach(el => {
            if (el !== footer) {
              el.classList.remove('is-active');
            }
          });
        }
        footer.classList.toggle('is-active');
      });
    });
  }
};
export default menu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/menu.js